import React, { useEffect, useState } from 'react';

import TrustpilotCarousel, {
  CarouselSubject,
} from '@/components/TrustpilotBar/Carousel';
import TrustpilotMicroStar from '@/components/TrustpilotBar/MicroStar';
import TrustpilotSlider from '@/components/TrustpilotBar/Slider';
import useIsMobileNew from '@/hooks/useIsMobileNew';

/**
 * 口碑区：Trustpilot Micro Star +
 * PC Carousel / 移动端 Slider
 * 中文 / 数学 / 英语学科页共用，Carousel 按学科使用各自的 Trustpilot 配置
 */
const ReviewCardGrid: React.FC<{
  subject?: CarouselSubject;
}> = ({ subject = 'chinese' }) => {
  const isMobile = useIsMobileNew();
  // SSR/水合完成前 isMobile 恒为 false，不能作为渲染依据
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const carousel = (
    <div className="rounded-[24px] bg-white px-6 py-8 shadow-wk1 xl:rounded-[36px] xl:px-10 xl:py-10">
      <TrustpilotCarousel subject={subject} />
    </div>
  );

  return (
    <>
      <div className="mt-6 flex justify-center lg:mt-10">
        <TrustpilotMicroStar />
      </div>

      <div className="container mt-8 xl:mt-10">
        {mounted ? (
          // 挂载后按真实视口只保留一个，避免两个 widget 同时初始化
          isMobile ? (
            <TrustpilotSlider variant={subject} />
          ) : (
            carousel
          )
        ) : (
          // 首帧（含 SSR 静态 HTML）用 CSS 断点区分，手机上第一眼就是 Slider
          <>
            <TrustpilotSlider variant={subject} className="lg:hidden" />
            <div className="hidden lg:block">{carousel}</div>
          </>
        )}
      </div>
    </>
  );
};

export default ReviewCardGrid;
